import $ from 'jquery'
import Swiper from 'swiper/bundle'

const { __ } = wp.i18n

const initializeBlock = function ($block) {
  const wrapper = $block.find('.testimonials-video-block__slider')
  if (!wrapper.length) {
    return
  }

  const swiper = new Swiper(wrapper[0], {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      prevEl: $block.find('.testimonials-video-block__nav--prev')[0],
      nextEl: $block.find('.testimonials-video-block__nav--next')[0],
    },
    pagination: {
      el: $block.find('.testimonials-video-block__pagination')[0],
      clickable: true,
    },
    autoHeight: true, // Activer le recalcul automatique de la hauteur
  })

  // Ajouter le recalcul auto de la hauteur à chaque changement de slide
  swiper.on('slideChange transitionEnd', function () {
    swiper.updateAutoHeight()
  })

  const buttonValue = $('.feed-testimony__readmore').find('span').text()

  // Gestion du bouton "Read more" pour ajuster la hauteur
  $('.feed-testimony__readmore').on('click', function () {
    $(this)
      .closest('.feed-testimony')
      .find('.feed-testimony__content')
      .toggleClass('read-more')

    const buttonText = $('.feed-testimony__content').hasClass('read-more')
      ? __('Read less', 'vn')
      : __('Read more', 'vn')
    $(this).find('span').text(buttonText)

    if (!$('.feed-testimony__content').hasClass('read-more')) {
      const offsetTop = $('.testimonials-video-block').offset().top // Position du conteneur
      const offsetAdjustment = 200

      $('html, body').animate(
        {
          scrollTop: offsetTop - offsetAdjustment,
        },
        100
      )
    }

    swiper.updateAutoHeight() // Recalculer la hauteur après modification du contenu
  })
}

$('.testimonials-video-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-testimonials-video',
    initializeBlock
  )
}
